<script setup lang="ts">

import SettingsView from "@/views/SettingsView.vue";
import {useDialogPluginComponent} from "quasar";
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const {dialogRef, onDialogCancel} = useDialogPluginComponent()
const loginStore = useLoginInfoStore();

</script>

<template>
  <q-dialog persistent ref="dialogRef" @hide="onDialogCancel" v-if="loginStore.isLoggedIn" @keydown.esc="onDialogCancel">
    <q-card
      class="tw-flex tw-flex-col tw-w-[85vw] tw-h-[85vh] desktop:tw-min-w-[800px] desktop:tw-min-h-[400px] mobile:tw-w-full mobile:tw-h-full tw-shadow-none tw-bg-namaBackground-bright-light dark:tw-text-white dark:tw-bg-namaBackground-bright-dark">
      <q-bar
        class="tw-flex-none tw-h-fit tw-min-h-8 tw-text-namaFontColor-light tw-bg-[#CED4DA] tw-px-2 tw-py-[6px] tw-flex tw-justify-between dark:tw-bg-[#212529] dark:tw-text-white">
        <div v-text="Translator.translateId('settings')"/>
        <q-btn dense flat @click="onDialogCancel" :title="Translator.translateId( 'close')" class="tw-h-fit">
          <NamaIcon default-icon="nm-win-close"/>
        </q-btn>
      </q-bar>
      <SettingsView :isInDialog="true"/>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
